import type { Locale } from "../types";
import { SUPPORTED } from "../types";

/** 지원 언어가 아닐 때 사용할 기본 언어. */
export const DEFAULT_LOCALE: Locale = "ko";

/**
 * 임의의 언어 코드를 서버로 보낼 ISO 639-1 소문자 코드로 정규화한다.
 *
 * i18n.language는 브라우저 감지 결과에 따라 `en-US`, `zh-CN`처럼
 * 지역 코드가 붙어 올 수 있으므로 앞부분만 사용한다.
 * 백엔드/멘트 서버는 소문자 ISO 코드(ko/en/zh/ja/id/es/fr/ru/de)를 받는다.
 *
 * 예: "en-US" → "en", "ZH" → "zh", "pt" → "ko"(미지원), "" → "ko"
 */
export function normalizeLocale(input?: string | null): Locale {
  if (!input) return DEFAULT_LOCALE;

  const head = input.trim().toLowerCase().split(/[-_]/)[0];

  return (SUPPORTED as readonly string[]).includes(head)
    ? (head as Locale)
    : DEFAULT_LOCALE;
}
